export default "__VITE_ASSET__Cdiu3Evm__"